/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type ArticleSelector_viewer$ref: FragmentReference;
export type ArticleSelector_viewer = {|
  +articlesForSelector: ?{|
    +articles: ?$ReadOnlyArray<?{|
      +id: string,
      +title: ?string,
    |}>
  |},
  +$refType: ArticleSelector_viewer$ref,
|};
*/


const node/*: ConcreteFragment*/ = {
  "kind": "Fragment",
  "name": "ArticleSelector_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "LocalArgument",
      "name": "search",
      "type": "String",
      "defaultValue": null
    }
  ],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": "articlesForSelector",
      "name": "articlesPaginate",
      "storageKey": null,
      "args": [
        {
          "kind": "Literal",
          "name": "hidden",
          "value": false,
          "type": "Boolean"
        },
        {
          "kind": "Literal",
          "name": "page",
          "value": 1,
          "type": "Int"
        },
        {
          "kind": "Literal",
          "name": "pageSize",
          "value": 5,
          "type": "Int"
        },
        {
          "kind": "Variable",
          "name": "plainSearch",
          "variableName": "search",
          "type": "String"
        }
      ],
      "concreteType": "ArticlesPagination",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "articles",
          "storageKey": null,
          "args": null,
          "concreteType": "Article",
          "plural": true,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "id",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "title",
              "args": null,
              "storageKey": null
            }
          ]
        }
      ]
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '3a54101f5a846b6dd7642318a944ee93';
module.exports = node;



// WEBPACK FOOTER //
// src/components/articles/__generated__/ArticleSelector_viewer.graphql.js